"use client";

import FullView from "@/components/common/FullView";
import SubmitForm from "@/components/request/renewal/SubmitForm";
import { cn } from "@/utils/cn";

// 섹션 컨테이너
const sectionClasses = cn(
  "relative flex h-full w-full max-w-[1200px] flex-col items-center",
  "desktop:flex-row desktop:items-center desktop:justify-between",
  "desktop:gap-12",
);

// 왼쪽 텍스트 + 폼 컨테이너
const leftContainerClasses = cn(
  "z-10 flex flex-col gap-8",
  "items-center px-side",
  "desktop:max-w-[550px] desktop:flex-shrink-0",
  "desktop:items-start desktop:px-0",
);

// 메인 타이틀
const titleClasses = cn("text-center text-36 font-bold", "leading-[1.3] tracking-tight", "desktop:text-left desktop:text-44");

// 서브 텍스트
const subtextClasses = cn(
  "text-14 text-center",
  "leading-[1.45] tracking-tight text-black/55",
  "tablet:text-18",
  "desktop:text-24 desktop:text-left",
);

// 오른쪽 이미지 외부 컨테이너
const imageOuterClasses = cn(
  "relative w-full",
  "mt-12 [@media(max-height:760px)]:mt-4",
  "desktop:mt-0 desktop:flex-1 desktop:max-w-[640px]",
  "desktop:flex desktop:justify-end",
);

function HeroSection() {
  return (
    <FullView as="section" className="w-full">
      <div className={sectionClasses}>
        {/* 왼쪽 텍스트 + 간이 문의 폼 */}
        <div className={leftContainerClasses}>
          {/* 메인 타이틀 */}
          <div className={titleClasses}>
            <h2 className="mb-0">채용 공고로</h2>
            <h2 className="mb-0">만날 수 없는 핵심 인재</h2>
            <h2>1주 안에 커피챗까지</h2>
          </div>

          {/* 서브 텍스트 */}
          <div className={subtextClasses}>
            <p className="mb-0">아웃바운드 채용을 자동화하는 AI 리크루터</p>
            <p>
              <span className="text-primary">✓</span> 업계 평균 대비{" "}
              <span className="font-bold text-primary">8배 채용 성사율</span>로 증명
            </p>
          </div>

          {/* 간이 문의 폼 (성함·이메일만) */}
          <div id="home-inquiry-form" className="w-full desktop:max-w-[440px]">
            <SubmitForm compact submitText="24시간 내 맞춤 채용 진단 받기" />
          </div>
        </div>

        {/* 오른쪽 이미지 영역 */}
        <div className={imageOuterClasses}>
          <picture>
            <source media="(min-width: 1024px)" srcSet="/image/home/hero-desktop.png" />
            <source media="(min-width: 768px)" srcSet="/image/home/hero-tablet.png" />
            {/* eslint-disable-next-line @next/next/no-img-element */}
            <img
              src="/image/home/hero-mobile.png"
              alt="AI 리크루터 플랫폼"
              fetchPriority="high"
              className="mx-auto aspect-[1428/1588] w-full object-contain [@media(max-height:760px)]:max-h-[360px] tablet:aspect-[3129/2009] desktop:aspect-[2704/2416]"
            />
          </picture>
        </div>
      </div>
    </FullView>
  );
}

export default HeroSection;
